<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} and exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="cur-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="cur-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="cur-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="cur-name" v-model="entity.name"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="bank" class="form-label">ISO Code</label>
              <input type="text" class="form-control" id="bank" v-model="entity.isoCode"/>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="office" class="form-label">Office</label>
              <select class="form-control" id="office" v-model="entity.office">
              </select>
            </div>
            <div class="form-group">
              <label for="cur-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="cur-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="cur-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="cur-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="acc-code" class="form-label">Accounts code</label>
              <input type="text" class="form-control" id="acc-code" v-model="entity.accountsCode"/>
            </div>
            <div class="form-group">
              <label for="dec" class="form-label">Decimal places</label>
              <input type="number" class="form-control" id="dec" v-model="entity.decimalPlaces"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="bank" class="form-label">Bank name</label>
              <input type="text" class="form-control" id="bank" v-model="entity.bank"/>
            </div>
            <div class="form-group">
              <label for="branch" class="form-label">Branch name</label>
              <input type="text" class="form-control" id="branch" v-model="entity.branch"/>
            </div>
            <div class="form-group">
              <label for="sc" class="form-label">Sort code</label>
              <input type="text" class="form-control" id="sc" v-model="entity.sortCode"/>
            </div>
            <div class="form-group">
              <label for="acc" class="form-label">Account name</label>
              <input type="text" class="form-control" id="acc" v-model="entity.accountName"/>
            </div>
            <div class="form-group">
              <label for="acc-num" class="form-label">Account number</label>
              <input type="text" class="form-control" id="acc-num" v-model="entity.accountNumber"/>
            </div>
            <div class="form-group">
              <label for="iban" class="form-label">IBAN Number</label>
              <input type="text" class="form-control" id="iban" v-model="entity.iabn"/>
            </div>
            <div class="form-group">
              <label for="swift" class="form-label">SWIFT code</label>
              <input type="text" class="form-control" id="swift" v-model="entity.swift"/>
            </div>
            <div class="form-group">
              <label for="source" class="form-label">Source</label>
              <input type="text" class="form-control" id="source" v-model="entity.source"/>
            </div>
            <div class="form-group">
              <label for="up" class="form-label">Last update</label>
              <input disabled type="text" class="form-control" id="up" v-model="entity.lastUpdate"/>
            </div>
            <div class="form-group">
              <label for="mod" class="form-label">Modified by</label>
              <input disabled type="text" class="form-control" id="mod" v-model="entity.modifiedBy"/>
            </div>
          </div>
        </div>
        <div v-if="tab === 'misc'">
          <div class="form-group">
            <label for="location-comments" class="form-label">Comments</label>
            <textarea class="form-control" rows="5" id="location-comments" v-model="entity.notes"></textarea>
          </div>
        </div>
      </div>
      -->
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import API from '../../../../api/endpoints.js'
  import event from '../../../../event.js'
  export default {
    name: 'Currency',
    mixins: [ AdminEntityMixin, HelperMixin ],
    data () {
      return {
        shouldUpdateCache: true,
        cachePropertyName: 'currencies',
        newEntityScreen: 'Admin - Currencies',
        editEntityScreen: 'Admin - Edit/View Currency',
        tab: 'main',
        entity: {
          id: null,
          name: null,
          code: null,
          isoCode: null
        },
        boxes: [],
        entityName: 'currency'
        /*
        entity: {
          code: '',
          name: '',
          office: '',
          decimalPlaces: '',
          bank: '',
          branch: '',
          sortCode: '',
          accountsCode: '',
          accountName: '',
          accountNumber: '',
          iabn: '',
          swift: '',
          source: '',
          lastUpdate: '',
          modifiedBy: '',
          notes: ''
        }
        */
      }
    },
    computed: {
      isValid () {
        return this.entity.code && this.entity.name &&
          this.entity.code.trim().length > 0 &&
          this.entity.name.trim().length > 0
      }
    },
    methods: {
      getBaseData () {
        return {
          id: null,
          name: null,
          code: null,
          isoCode: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Currency/Currency.vue